export default {
  "duplicate": "ចំលង",
  "save": "រក្សាទុក",
  "discard": "ត្រលប់",
  "additionalInfo": "ពត៍មានបន្ថែម",
  "loading": "កំពុងដំណេីរការ...",
};
